export default {
  REALTIME_CLIENT_INITIALIZED: '@realtime-client-initialized',
  CHAT_STARTED: '@realtime-client-chat-started',
  SG_SITE_PAGE_LOADED: '@realtime-client-sg-site-page-loaded',
  CANNOT_START_NEW_SALES_CHAT_DUE_TO_PROBABILITY: '@realtime-client-cannot-start-sales-chat-due-to-probability',

  SET_CHAT_WINDOW_MINIMIZED: '@realtime-client-set-chat-window-minimized',
  SET_CHAT_WINDOW_IS_CLOSABLE: '@realtime-client-set-chat-window-is-closable',

  PREFILL_USER_DATA: '@realtime-client-prefill-user-data',
  ON_SET_OPTIONS: '@realtime-client-on-set-options',

  LOG_USER_ACTION: '@realtime-client/log-user-action',

  // events triggered from main app
  START_CHAT_TECHNICAL: '@realtime-client/start-chat-technical',
  START_CHAT_PRESALE: '@realtime-client/start-chat-presale',
  START_CHAT_AUTHENTICATED_INQUIRY: '@realtime-client/start-chat-authenticated-inquiry',
  START_CHAT_CANCELLATION: '@realtime-client/start-chat-cancellation',
  CLIENT_TOKEN_UPDATED: '@realtime-client/client-token-updated',
  FAILED_TO_LOAD_VISITOR_TOKEN: '@realtime-client/failed-to-load-visitor-token',
  FAILED_TO_AUTHENTICATE_WITH_CLIENT_TOKEN: '@realtime-client/failed-to-authenticate-with-client-token',

  INDICATE_CHAT_IS_ACTIVE: '@realtime-client/indicate-chat-is-active',

  ON_AFTER_CHAT_RENDER: '@realtime-client-on-chat-render',
  ON_AFTER_CHAT_STARTED: '@realtime-client-on-chat-started',
  ON_AFTER_CHAT_CLOSE: '@realtime-client-on-chat-close',
  ON_INQUIRY_CHAT_SUBMIT: '@realtime-client-on-inquiry-chat-submit',

  LOGOUT_FROM_SITE_TOOLS: '@realtime-client-logout-from-site-tools',
  LOGOUT_USER_FROM_UA: '@realtime-client-logout-from-ua'
};
